import { EventEmitter, Injectable } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { shareReplay, startWith } from 'rxjs/operators';
import { AmountsCargoEnum } from 'src/app/core/enums/amountsCargo.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { ServiceType } from 'src/app/core/interfaces/serviceType';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Utils } from 'src/app/core/resources/utils';

@Injectable({
  providedIn: 'root'
})
export class BellAlertService {
  public static uncares: Array<Cargo> = [];
  public static filters: string = '';
  public static total: number = 0;
  // Gate de "el preview de servicios sin atender / con error de manifiesto ya se
  // ejecutó en esta entrada a la sección de rutas". Evita relanzar la consulta
  // (idéntica al listado + uncared=true) en cada cambio de tab o de filtro cuando
  // no hay servicios sin atender que lo dejen "pegado" vía `uncares`. Es estático,
  // así que solo un reload lo reinicia (el estado estático se pierde al recargar).
  public static previewChecked: boolean = false;
  public static onUncareStacked: EventEmitter<any> = new EventEmitter();
  private static readonly alertTick$: Observable<number> = interval(5000).pipe(
    startWith(0),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private utils: Utils) { }

  public get alertTicks(): Observable<number> {
    return BellAlertService.alertTick$;
  }

  static get cargos(): Cargo[] {
    return BellAlertService.uncares;
  }

  public static stack(cargos: Cargo[], filters: string = '', total: number = 0) {
    BellAlertService.uncares = cargos;
    BellAlertService.filters = filters;
    BellAlertService.total = total;
    if (cargos && cargos.length) BellAlertService.onUncareStacked.emit(cargos);
  }

  public validateTimeCargo(date: Date, cargo: Cargo, isEmpty: boolean) {
    let diff = DateManager.dateDiff(new Date(), null, date, null, 'minutes');

    // Escort service
    if (this.utils.isEscortedService(cargo) || this.utils.isSatelliteLockService(cargo)) {
      if (diff >= AmountsCargoEnum.ESCORT_SERVICE_ALERT_MINS)
        return ({ diff, amount: AmountsCargoEnum.ESCORT_SERVICE_ALERT_MINS })
      return null;
    }

    const amount = this.utils.getNestedValue(cargo, 'cargoFeature.cargoMeasure.amount');
    // Vacío
    if (isEmpty && diff >= AmountsCargoEnum.EMPTY_ALERT_MINS)
      return ({ diff, amount: AmountsCargoEnum.EMPTY_ALERT_MINS })
    // Amarillo 3H
    if (amount >= AmountsCargoEnum.LOW_START && amount <= AmountsCargoEnum.LOW_END && diff >= AmountsCargoEnum.LOW_ALERT_MINS)
      return ({ diff, amount: AmountsCargoEnum.LOW_ALERT_MINS })
    // Rojo 2H
    if (amount >= AmountsCargoEnum.MEDIUM_START && amount <= AmountsCargoEnum.MEDIUM_END && diff >= AmountsCargoEnum.MEDIUM_ALERT_MINS)
      return ({ diff, amount: AmountsCargoEnum.MEDIUM_ALERT_MINS })
    // Morado 1H
    if (amount >= AmountsCargoEnum.HIGH_START && amount <= AmountsCargoEnum.HIGH_END && diff >= AmountsCargoEnum.HIGH_ALERT_MINS)
      return ({ diff, amount: AmountsCargoEnum.HIGH_ALERT_MINS })
    return null;
  }

}
